module.exports = __webpack_public_path__ + "static/ukraine-5f9a61584d488bd1d4628ceb6ad45a4c.webp";